import Email from './Email'

export default Email
// eslint-disable-next-line import/export
export * from './Email'
